import React from "react";
import { useNavigate } from "react-router-dom";
import arrowImg from '../Image/arrow.png'

const font = "Open Sans, sans-serif";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  // Remove time portion like "00:00:00"
  return dateStr.split(" ")[0];
};

const Machineitem2 = ({
  id,
  imageUrl,
  topNumber1,
  manufacture,
  model,
  statuses,
  serviceTickets,
  cmaStartDate,
  cmaEndingDate,
  cmaBalance,
}) => {
  const navigate = useNavigate();

  const handleArrowClick = () => {
    if (id) {
      sessionStorage.setItem('machineId', id);
      navigate(`/CAMdetails/${id}`);
    }
  };

  return (
    <div
      onClick={handleArrowClick}
      style={{
        display: "flex",
        marginBottom: "15px",
        boxShadow: "2px 10px 25px -21px #8e8787",
        cursor: "pointer",
        padding: "15px 0",
        borderBottom: "1px solid #f0f0f0",
        backgroundColor: "#fff",
        borderRadius: "5px",
      }}
    >
      {/* Left: Image + Name + Status */}
      <div style={{
        width: "130px",
        minWidth: "130px",
        textAlign: "center",
        flexShrink: 0,
        padding: "5px 10px",
      }}>
        <img src={imageUrl} alt="Machine" style={{ width: "90px", display: "block", margin: "0 auto 8px auto" }} />
        <p style={{ fontSize: "11px", lineHeight: "1.4", margin: "0 0 6px 0", fontFamily: font, color: "#333", wordBreak: "break-all" }}>
          {topNumber1}
        </p>
        <span style={{
          backgroundColor: "#E8F5FC",
          color: "#136390",
          padding: "4px 14px",
          borderRadius: "10px",
          fontSize: "12px",
          fontFamily: font,
          whiteSpace: "nowrap",
          display: "inline-block",
        }}>
          {statuses ? statuses.charAt(0).toUpperCase() + statuses.slice(1).toLowerCase() : statuses}
        </span>
      </div>

      {/* Right: Details + CMA Balance */}
      <div style={{
        borderLeft: "1px solid #dadada",
        paddingLeft: "20px",
        flex: 1,
        paddingTop: "10px",
        paddingBottom: "10px",
        position: "relative",
      }}>
        <img
          src={arrowImg}
          alt="Arrow"
          onClick={handleArrowClick}
          style={{ position: "absolute", right: "15px", top: "15px", cursor: "pointer", width: "28px" }}
        />

        {/* Machine info row */}
        <div style={{ display: "flex", justifyContent: "space-between", width: "90%", marginBottom: "15px" }}>
          <div style={{ flex: 1 }}>
            <p style={{ margin: "0 0 4px 0", fontSize: "13px", fontFamily: font, fontWeight: 600, color: "#555" }}>Manufacture</p>
            <span style={{ fontSize: "15px", fontFamily: font, fontWeight: 700, color: "#333" }}>{manufacture}</span>
          </div>
          <div style={{ flex: 1 }}>
            <p style={{ margin: "0 0 4px 0", fontSize: "13px", fontFamily: font, fontWeight: 600, color: "#555" }}>Model</p>
            <span style={{ fontSize: "15px", fontFamily: font, fontWeight: 700, color: "#333" }}>{model || "—"}</span>
          </div>
          <div style={{ flex: 1 }}>
            <p style={{ margin: "0 0 4px 0", fontSize: "13px", fontFamily: font, fontWeight: 600, color: "#555" }}>Service Tickets</p>
            <span style={{ fontSize: "15px", fontFamily: font, fontWeight: 700, color: "#333" }}>{serviceTickets}</span>
          </div>
          <div style={{ flex: 1 }}>
            <p style={{ margin: "0 0 4px 0", fontSize: "13px", fontFamily: font, fontWeight: 600, color: "#555" }}>CMA Start Date</p>
            <span style={{ fontSize: "15px", fontFamily: font, fontWeight: 700, color: "#333" }}>{formatDate(cmaStartDate)}</span>
          </div>
          <div style={{ flex: 1 }}>
            <p style={{ margin: "0 0 4px 0", fontSize: "13px", fontFamily: font, fontWeight: 600, color: "#555" }}>CMA End Date</p>
            <span style={{ fontSize: "15px", fontFamily: font, fontWeight: 700, color: "#333" }}>{formatDate(cmaEndingDate)}</span>
          </div>
        </div>

        {/* CMA Balance */}
        <div style={{ borderTop: "1px solid #eee", paddingTop: "10px" }}>
          <h3 style={{ color: "#017cc2", fontSize: "16px", margin: "0 0 10px 0", fontFamily: font, fontWeight: 700 }}>CMA Balance</h3>
          <div style={{ display: "flex", justifyContent: "space-between", width: "90%" }}>
            <div style={{ flex: 1 }}>
              <p style={{ margin: "0 0 4px 0", fontSize: "12px", fontFamily: font, fontWeight: 600, color: "#555" }}>Parts Cap Remaining</p>
              <span style={{ fontSize: "15px", fontFamily: font, fontWeight: 700, color: "#017cc2" }}>{cmaBalance.partsCapRemaining}</span>
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ margin: "0 0 4px 0", fontSize: "12px", fontFamily: font, fontWeight: 600, color: "#555" }}>Calibration Remaining</p>
              <span style={{ fontSize: "15px", fontFamily: font, fontWeight: 700, color: "#017cc2" }}>{cmaBalance.calibrationRemaining}</span>
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ margin: "0 0 4px 0", fontSize: "12px", fontFamily: font, fontWeight: 600, color: "#555" }}>Support Hours</p>
              <span style={{ fontSize: "15px", fontFamily: font, fontWeight: 700, color: "#017cc2" }}>{cmaBalance.supportHours}</span>
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ margin: "0 0 4px 0", fontSize: "12px", fontFamily: font, fontWeight: 600, color: "#555" }}>On Site service visit</p>
              <span style={{ fontSize: "15px", fontFamily: font, fontWeight: 700, color: "#017cc2" }}>{cmaBalance.onSiteServiceVisit}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Machineitem2;
